module.exports = __webpack_public_path__ + "static/media/3.5245d3e9.jpg";